import { render, staticRenderFns } from "./volt.vue?vue&type=template&id=77b845de"
import script from "./volt.vue?vue&type=script&lang=js"
export * from "./volt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports